import React from 'react';

import { Link } from '@mui/material';

import { HeaderLogo } from '../../../components/header-components/HeaderLogo/HeaderLogo';
import { SolutionType } from '../../../constants/user-info/solutionType';

type LogoLinkProps = {
  solution?: SolutionType | null;
};

const LogoLink = ({ solution }: LogoLinkProps) => {
  return (
    <Link href="/">
      <HeaderLogo solution={solution} />
    </Link>
  );
};

export { LogoLink };
